import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';

import * as styles from '@common/blocks/flex/flex.module.scss';

const FlexImages = ({ data }) => {
  const {
    showImages,
    imagePositionTop,
    imagePositionTopLg,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    images,
  } = data;
  return (
    <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx('col text-center', imageWidth, {
      [`d-none ${showImages}`]: showImages,
      'mb-3 mb-md-0': imagePositionTop,
      'mb-lg-5': imagePositionTopLg,
      [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      {images.map(image => (
        <Img
          key={image.id}
          loading='eager'
          image={image.gatsbyImageData}
          file={image.file}
          alt={image.description}
          style={{ maxHeight: imageMaxHeight }}
          imgStyle={{ width: '100%', objectFit: imageMaxHeight ? 'contain' : ''}}
        />  
      ))}
    </div>
  )
}

export default FlexImages
